import { fabric } from 'fabric';
import getStroke from 'perfect-freehand';
import polygonClipping from 'polygon-clipping';

export function getSvgPathFromStroke(stroke) {
  if (!stroke.length) return '';

  const d = stroke.reduce(
    (acc, [x0, y0], i, arr) => {
      const [x1, y1] = arr[(i + 1) % arr.length];
      acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2);
      return acc;
    },
    ['M', ...stroke[0], 'Q'],
  );

  d.push('Z');
  return d.join(' ');
}

export function getFlatSvgPathFromStroke(stroke) {
  if (stroke.length) {
    const poly = polygonClipping.union([stroke]);

    const d = [];

    for (const face of poly) {
      for (const points of face) {
        d.push(getSvgPathFromStroke(points));
      }
    }

    return d.join(' ');
  } else {
    return '';
  }
}

const LudusBrush = fabric.util.createClass(fabric.BaseBrush, {
  size: 20,
  thinning: 0.85,
  smoothing: 0.01,
  streamline: 0.5,
  simulatePressure: true,
  color: 'rgba(0,0,0,0)',

  initialize: function(canvas) {
    this.canvas = canvas;
    this._points = [];
    this.size = canvas.freeDrawingBrush.size || this.size;
    this.fill = canvas.freeDrawingBrush.color || this.color;
    this.thinning = canvas.freeDrawingBrush.thinning || this.thinning;
    this.simulatePressure =
      canvas.freeDrawingBrush.simulatePressure || this.simulatePressure;
    this.pointermove = this.onPointerMove.bind(this);
  },

  /**
   * Inovoked on mouse down
   * @param {Object} pointer
   */
  onMouseDown: function(pointer, options) {
    if (!this.canvas._isMainEvent(options.e)) {
      return;
    }
    this._prepareForDrawing(pointer);
    // capture coordinates immediately
    // this allows to draw dots (when movement never occurs)
    // this._captureDrawingPath(pointer);
    this._render();
  },

  /**
   * Inovoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function(pointer, options) {
    // DO NOTHING TO PREVENT WEIRD FABRIC DEFAULT BEHAVIOR
    // issue: it's calling twice this function per frame leading to weird results and poor perf
  },

  /**
   * On mouseup after drawing the path on contextTop canvas
   * we use the points captured to create an new fabric path object
   * and add it to the fabric canvas.
   */
  _finalizeAndAddPath: function() {
    if (this.currentStroke && this._points.length) {
      var path = new fabric.LudusBrushPath(
        {
          fill: this.fill,
          ludus: { type: 'brushPath' },
          points: this._points,
          size: this.size,
          thinning: this.thinning,
          smoothing: this.smoothing,
          streamline: this.streamline,
          simulatePressure: this.simulatePressure,
        },
        this.currentStroke,
      );
      this.canvas.clearContext(this.canvas.contextTop);
      this.canvas.add(path);
      this.canvas.fire('brushPath:created', { target: path });
    }
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function(options) {
    document.removeEventListener('pointermove', this.pointermove);
    if (!this.canvas._isMainEvent(options.e)) {
      return true;
    }
    this._finalizeAndAddPath();
    return false;
  },

  getDistance(x1, y1, x2, y2) {
    const y = x2 - x1;
    const x = y2 - y1;

    return Math.sqrt(x * x + y * y);
  },
  /**
   * @private
   * @param {Object} pointer Actual mouse position related to the canvas.
   */

  onPointerMove: function(e) {
    var pointer = this.canvas.getPointer(e);
    const lastP = this._points?.slice(-1)[0];
    let distance = 100;
    if (lastP) {
      distance = this.getDistance(pointer.x, pointer.y, lastP[0], lastP[1]);
    }

    if (distance >= 1) {
      this._points = [
        ...this._points,
        [
          Math.round(pointer.x * 100) / 100,
          Math.round(pointer.y * 100) / 100,
          e.pressure * e.pressure,
        ],
      ];
      this.canvas.clearContext(this.canvas.contextTop);
      this._render({ isDrawing: true });
    }
  },

  _prepareForDrawing: function(pointer) {
    this.fill = this.canvas.freeDrawingBrush.color;
    this.simulatePressure = this.canvas.freeDrawingBrush.simulatePressure;
    var p = new fabric.Point(pointer.x, pointer.y);
    document.removeEventListener('pointermove', this.pointermove);
    document.addEventListener('pointermove', this.pointermove);
    this._reset();
    this.canvas.contextTop.moveTo(p.x, p.y);
  },

  _reset: function() {
    this._points = [];
    this._setBrushStyles();
    this._setShadow();
  },

  _render: function(props) {
    if (props?.isDrawing && this._points) {
      var ctx = this.canvas.contextTop;
      ctx.save();

      ctx.transform(...this.canvas.VPT);
      ctx.fillStyle = this.fill;
      this.currentStroke = getStroke(this._points, {
        size: this.size,
        thinning: this.thinning,
        smoothing: this.smoothing,
        streamline: this.streamline,
        simulatePressure: this.simulatePressure,
      });
      const myPath = new Path2D(getSvgPathFromStroke(this.currentStroke));
      ctx.fill(myPath);
      ctx.restore();
    }
  },
});
export default LudusBrush;
